export const dashboard = {
  title: "Dashboard",
  filters: {
    accommodation: "Accommodation",
    allAccommodations: "All accommodations",
    period: "Period",
    periodOptions: {
      today: "Today",
      week: "Week",
      month: "Month",
      year: "Year",
    },
  },
  actions: {
    createBooking: "Create booking",
  },
  pendingWidget: {
    title: "Pending actions",
    subtitle: "Payments, requests and rooms to assign.",
    oneRequest: "request",
    manyRequests: "requests",
    onePayment: "payment",
    manyPayments: "payments",
    oneUnassigned: "to assign",
    manyUnassigned: "to assign",
    loading: "Loading pending actions...",
    emptyTitle: "No pending actions",
    emptyText: "When a new request comes in or a booking is awaiting payment, it will appear here.",
    noName: "No name",
    accommodation: "Accommodation",
    guest: "guest",
    guests: "guests",
    requestShort: "Request",
    pendingPaymentShort: "Awaiting payment",
    unassignedShort: "Assign room",
    approve: "Approve",
    reject: "Reject",
    viewAll: "View all bookings",
    modalApproveTitle: "Approve request",
    modalRejectTitle: "Reject request",
    modalApproveText1: "You're about to approve the request from",
    modalApproveText2: "If this booking uses online payment, it will move to awaiting payment.",
    modalRejectText1: "You're about to reject the request from",
    modalRejectText2: "You can provide a reason to send it to the guest by email.",
    rejectReasonLabel: "Rejection reason",
    rejectReasonPlaceholder: "Select a reason",
    reasonDatesUnavailable: "The dates are no longer available",
    reasonPriceUnavailable: "The rate is no longer available",
    reasonMinimumStay: "Doesn't meet the minimum stay",
    reasonHouseRules: "Doesn't meet the accommodation rules",
    reasonOther: "Other reason",
    rejectReasonOtherPlaceholder: "Write the rejection reason",
    rejectReasonRequired: "You must select a rejection reason.",
    rejectReasonOtherRequired: "You must write the rejection reason.",
    cancel: "Cancel",
    confirmApprove: "Yes, approve",
    confirmReject: "Yes, reject",
    statusUpdatedSuccess: "Status updated successfully.",
    statusUpdatedError: "Could not update the status."
  },

  stats: {
    totalReservations: {
      today:   "Bookings today",
      week:    "Bookings this week",
      month:   "Bookings this month",
      year:    "Bookings this year",
      default: "Total bookings",
    },
    checkIns: {
      today:   "Check-ins today",
      week:    "Check-ins this week",
      month:   "Check-ins this month",
      year:    "Check-ins this year",
      default: "Check-ins",
    },
    occupancy: {
      today:   "Occupancy today",
      week:    "Weekly occupancy",
      month:   "Monthly occupancy",
      year:    "Annual occupancy",
      default: "Occupancy",
    },
    revenue: {
      today:   "Today's revenue",
      week:    "Weekly revenue",
      month:   "Monthly revenue",
      year:    "Annual revenue",
      default: "Revenue",
    },
  },
  section3: {
    title: "Upcoming bookings",
    subtitle: "List of upcoming arrivals for your accommodation",
    timeFilters: {
      upcoming: "Upcoming",
      thisWeek: "This week",
      today: "Today",
      tomorrow: "Tomorrow",
      month: "Month",
    },
    table: {
      headers: {
        responsible: "Responsible",
        checkInDate: "Check-in date",
        entry: "Entry",
        guests: "Guests",
        status: "Status",
      },
    },
    empty: {
      today: {
        title: "You have no arrivals for today",
        description:
          "When you have a new arrival scheduled for today, it will appear here with its important details.",
      },
      default: {
        title: "You have no upcoming arrivals",
        description:
          "When you have new scheduled arrivals, they will appear here along with their important details.",
      },
    },
    loading: "Loading bookings...",
    statuses: {
      inProgress: "In progress",
      complete: "Complete",
      pending: "Pending",
      approved: "Approved",
    },
    actions: {
      replyOnWhatsApp: "Reply on WhatsApp",
    },
    nights: "{count} night | {count} nights",
  },
  section4: {
    title: "Revenue breakdown",
    total: "Total revenue",
    emptyChart: "No data available",
    noData: "There is no revenue data to display",
  },
  section5: {
    title: "Total revenue",
    datasetLabel: "Revenue",
    filters: {
      weekly: "Weekly",
      monthly: "Monthly",
      "6m": "6 Months",
      "12m": "12 Months",
      "24m": "24 Months",
    },
    loading: "Loading data...",
    errors: {
      load: "Error loading data",
      connection: "Connection error",
    },
  },
  design: {
    title: `Panel design`,
    reorder: `Reorder`,
    active: `Active`,
    theme: `Theme`,
    color: `Color`,
    green: `Green`,
    system: `System`,
    white: `White`,
    sidebar: `Sidebar`,
    black: `Black`,
  },
  earlyCheckin: {
    earlyShort: `Early`,
    arrivesShort: `Arrives`,
    arrivalAt: `At {time}`,
    requested: `Early check-in requested`,
    arrivalRequested: `Arrival time requested`,
  },
};
